import React, { useState } from 'react';
import { Video, Calendar, Clock, User, Check } from 'lucide-react';

const VideoMeetingSection = ({ caseData, portalType = 'individual' }) => {
  const primaryColor = portalType === 'business' ? '#1E3A8A' : '#10B981';
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [meetingPurpose, setMeetingPurpose] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const availableTimes = [
    '09:00 صباحاً',
    '10:00 صباحاً',
    '11:00 صباحاً',
    '01:00 مساءً',
    '02:00 مساءً',
    '03:00 مساءً',
    '04:00 مساءً'
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    // سيتم إرسال الطلب إلى الباك إند
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      setSelectedDate('');
      setSelectedTime('');
      setMeetingPurpose('');
    }, 3000);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border-2 border-gray-200 p-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-[#8B5CF6] to-[#A78BFA] rounded-xl flex items-center justify-center">
          <Video className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h2 className="text-3xl font-black  style={{ color: primaryColor }}">حجز اجتماع عن بعد</h2>
      </div>

      {/* معلومات المحامي */}
      <div className="bg-gradient-to-br from-purple-50 to-white border-2 border-purple-100 rounded-xl p-6 mb-8">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-[#C8A870] to-[#D4B988] rounded-xl flex items-center justify-center">
            <User className="w-8 h-8 text-white" strokeWidth={2.5} />
          </div>
          <div>
            <h3 className="text-xl font-black text-gray-900">{caseData.assignedLawyer?.name}</h3>
            <p className="text-[#8B5CF6] font-bold">{caseData.assignedLawyer?.title}</p>
          </div>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed">
          يمكنك حجز اجتماع عن بعد مع المحامي المسؤول لمناقشة تفاصيل قضيتك. اختر التاريخ والوقت المناسب لك.
        </p>
      </div>

      {showSuccess && (
        <div className="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-6 mb-8">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center">
              <Check className="w-6 h-6 text-white" strokeWidth={3} />
            </div>
            <div>
              <h4 className="text-lg font-black text-emerald-900">تم إرسال طلب الاجتماع بنجاح!</h4>
              <p className="text-sm text-emerald-700">سيتم التواصل معك قريباً لتأكيد الموعد</p>
            </div>
          </div>
        </div>
      )}

      {/* نموذج الحجز */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="flex items-center gap-2 text-sm font-bold text-gray-700 mb-3">
            <Calendar className="w-5 h-5 text-[#8B5CF6]" />
            <span>اختر التاريخ</span>
          </label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            min={new Date().toISOString().split('T')[0]}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B5CF6] focus:outline-none font-bold"
            required
          />
        </div>

        <div>
          <label className="flex items-center gap-2 text-sm font-bold text-gray-700 mb-3">
            <Clock className="w-5 h-5 text-[#8B5CF6]" />
            <span>اختر الوقت</span>
          </label>
          <select
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B5CF6] focus:outline-none font-bold"
            required
          >
            <option value="">اختر الوقت...</option>
            {availableTimes.map((time) => (
              <option key={time} value={time}>{time}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="flex items-center gap-2 text-sm font-bold text-gray-700 mb-3">
            <Video className="w-5 h-5 text-[#8B5CF6]" />
            <span>الغرض من الاجتماع</span>
          </label>
          <textarea
            value={meetingPurpose}
            onChange={(e) => setMeetingPurpose(e.target.value)}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-[#8B5CF6] focus:outline-none font-semibold h-32 resize-none"
            placeholder="مثال: مناقشة مستجدات القضية والخطوات القادمة"
            required
          />
        </div>

        <button 
          type="submit"
          className="w-full px-8 py-4 bg-gradient-to-r from-[#8B5CF6] to-[#A78BFA] hover:from-[#7C3AED] hover:to-[#8B5CF6] text-white rounded-xl transition-all font-black text-lg shadow-lg hover:shadow-xl flex items-center justify-center gap-3"
        >
          <Video className="w-6 h-6" strokeWidth={2.5} />
          <span>إرسال طلب الاجتماع</span>
        </button>
      </form>

      {/* معلومات إضافية */}
      <div className="mt-8 bg-blue-50 border-2 border-blue-100 rounded-xl p-5">
        <h4 className="font-black  style={{ color: primaryColor }} mb-3">ما يتضمنه الاجتماع:</h4>
        <ul className="space-y-2 text-sm text-gray-700">
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 bg-[#C8A870] text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">✓</span>
            <span>فيديو عالي الجودة مع إمكانية مشاركة الشاشة</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 bg-[#C8A870] text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">✓</span>
            <span>تسجيل الاجتماع للرجوع إليه لاحقاً</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 bg-[#C8A870] text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">✓</span>
            <span>إمكانية رفع مستندات أثناء الاجتماع</span>
          </li>
          <li className="flex items-start gap-2">
            <span className="w-5 h-5 bg-[#C8A870] text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 mt-0.5">✓</span>
            <span>تشفير كامل للاجتماع لضمان الخصوصية</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default VideoMeetingSection;